import { useAtomValue } from "jotai";
import { questionnaireVisibilityAtom } from "../state/questionnaireVisibilityAtom";

/**
 * Get a single question's visibility. Only re-renders when this visibility changes.
 *
 * @example const isVisible = useVisibility('optional_field');
 * @see useVisibilityMap - all visibility states
 */
export function useVisibility(questionName: string): boolean | undefined {
  return useAtomValue(questionnaireVisibilityAtom(questionName));
}
